<script setup lang="ts">
import type { PromoCard } from '~/types/storyblok/promo-card'
import type { EdgeStyles } from '~/types/storyblok/shared'
import { getEdgeClasses } from '~/lib/getEdgeClasses'
import { normalizePromoBlock } from '~/types/storyblok/promo-card'

const props = defineProps<{
  blok: PromoCard
  edgeStyle: EdgeStyles
  index: number
  noText: boolean
}>()

const edgeClass = computed(() => getEdgeClasses(props.edgeStyle))
const promo = computed(() => normalizePromoBlock(props.blok))
const elementType = computed(() => props.blok.link.cached_url ? resolveComponent('NuxtLink') : 'div')
</script>

<template>
  <div class="image-link">
  <PromoCardText
    v-if="!noText && blok.textContentAboveTheImage"
    :blok="blok"
    :no-text="noText"
    :element-type="elementType"
    :class="[edgeClass]"
  />

    <!-- Media -->
    <Breakpoint until="tablet">
      <PromoCardAsset
        v-if="promo.asset.default"
        :asset="promo.asset.default"
        :data-parent-position="$attrs['data-position'] as number"
        :blok="blok"
        :url="promo.link"
      />
    </Breakpoint>
    <Breakpoint from="tablet">
      <PromoCardAsset
        v-if="promo.asset.desktopOverride"
        :asset="promo.asset.desktopOverride"
        :data-parent-position="$attrs['data-position'] as number"
        :blok="blok"
        :url="promo.link"
      />
      <PromoCardAsset
        v-else-if="promo.asset.default"
        :asset="promo.asset.default"
        :data-parent-position="$attrs['data-position'] as number"
        :blok="blok"
        :url="promo.link"
      />
    </Breakpoint>
  <PromoCardText
    v-if="!noText && !blok.textContentAboveTheImage"
    :blok="blok"
    :element-type="elementType"
    :class="[edgeClass]"
  />
  </div>
</template>

<style lang="scss" scoped>
@import 'assets/scss/typography/body';
@import 'assets/scss/rules/edges';
@import 'assets/scss/rules/breakpoints';


.teeth {
  @include teeth;
  margin-top: -1.2rem;
}

.scallop {
  @include scallop;
  margin-top: -1.6rem;
}

.wave {
  @include wave;
  margin-top: -1.2rem;
}

.image-link {
  border: 2px solid transparent;
    &:focus-visible {
      border: 2px solid var(--black);
      border-radius: 2px;
      outline:none;
    }
  }
</style>
